export const UI_CONSTANTS = {
  BUTTONS: {
    HEIGHT: 40,
    PERIOD_MIN_WIDTH: 180,
    PERIOD_PADDING: 32,
    PERIOD_CHEVRON_WIDTH: 20,
  },
  IMAGES: {
    THUMBNAIL_SIZE: 112,
    THUMBNAIL_INNER_SIZE: 104,
    COLLECTION_THUMBNAIL_SIZE: 384,
    COLLECTION_THUMBNAIL_INNER_SIZE: 378,
    COLLECTION_THUMBNAIL_MOBILE_SIZE: 272,
    COLLECTION_THUMBNAIL_MOBILE_INNER_SIZE: 266,
    THUMBNAIL_FRAME_PADDING: 4,
    THUMBNAIL_BORDER_RADIUS: 4,
    COLLECTION_THUMBNAIL_BORDER_RADIUS: 5,
    THUMBNAIL_BORDER_COLOR: "#D1D5DB",
  },
  LAYOUT: {
    ACTIVITY_PAGE_MAX_WIDTH: 1080,
  },
  PAGINATION: {
    DEFAULT_RECORDS_PER_PAGE: 25,
    ACTIVITY_ITEMS_PER_PAGE: 10,
  },
  RESPONSIVE: {
    SCREEN_WIDTH_FORCE_BLOCK_DISPLAY: 1500,
  },
  Z_INDEX: {
    MODAL: 9999,
    DROPDOWN: 30,
    OVERLAY: 10,
  },
};
